export const parseCookieHeader = (cookie: string) =>
    cookie
        .split(';')
        .map(c => c.split('='))
        .reduce((acc, v) => {
            acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(
                v[1].trim()
            )
            return acc
        }, {})

export const formatSetCookieHeader = ({
    name,
    value,
    maxAge,
    secure = true,
}: {
    name: string
    value: string
    maxAge: number
    secure?: boolean
}) => {
    let cookieStr = `${encodeURIComponent(name)}=${encodeURIComponent(
        value
    )}; Max-Age=${maxAge}; Path=/; HttpOnly; SameSite=lax;`

    if (secure) {
        cookieStr += ' Secure;'
    }
    return cookieStr
}
